import { useGetEmployers } from 'queries';

export const useGetTableData = () => {
  const { data, isFetching, isError, refetch } = useGetEmployers();
  return { data, isFetching, isError, refetch };
};
